import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreRoomStateFeedback,
} from '../firestore/RoomStateFeedback'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateFeedback extends ObservableModelWithDecorators<FirestoreRoomStateFeedback> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateFeedback>
  ) {
    super(repository, doc)
  }
}
